const PRODUCT_GROUPING_TYPES = {
	FRANCHISE: "franchise",
	TECHNOLOGY: "technology",
};

export default PRODUCT_GROUPING_TYPES;
